import { ErrorMessage, Field, Form, Formik } from 'formik';
import moment from 'moment';
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import * as Yup from 'yup';
import { Button, Spinner } from 'reactstrap';
import { RiErrorWarningFill } from 'react-icons/ri';

const schema = Yup.object().shape({
  UTR: Yup.string().required('Please Enter UTR number')
});

const App2 = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const data = JSON.parse(atob(id));

  useEffect(() => {
    document.title = data?.ap;
    if (data?.e < moment().unix()) return navigate('/expire');
  }, [navigate, data?.e, data?.ap]);

  const handleCopy = (data) => {
    navigator.clipboard.writeText(data);
    Swal.fire({
      title: 'Copied',
      confirmButtonColor: '#79CBF2',
      confirmButtonText: 'Ok',
      reverseButtons: true
    });
  };

  if (!data) {
    return (
      <Spinner
        animation='grow'
        style={{
          height: '5rem',
          width: '5rem'
        }}
      />
    );
  }

  return (
    <div
      className='container-sm'
      style={{ maxWidth: '1100px', minHeight: '100vh', paddingTop: '3rem' }}
    >
      <div className='head'>
        <img src='/images/upi.png' alt='upi' style={{ width: '150px' }} />
      </div>
      <div className='app2-box' style={{ marginTop: '2rem' }}>
        <div className='app2-box-head'>
          <p>Step 1.Copy UPI information</p>
        </div>
        <div className='app2-box-body justify-between'>
          <div
            style={{
              display: 'flex',
              gap: '.5rem',
              alignItems: 'center',
              fontWeight: 'bold'
            }}
          >
            <p>Amount:</p>
            <p className='red'>{data.a}</p>
          </div>
          <Button className='app2-copy-btn' onClick={() => handleCopy(data.a)}>
            copy
          </Button>
        </div>
        <div className='app2-box-body justify-between'>
          <div
            style={{
              display: 'flex',
              gap: '.5rem',
              alignItems: 'center'
            }}
          >
            <p style={{ fontWeight: 'bold' }}>UPI ID / VPI ID</p>
            <p>{data.up}</p>
          </div>
          <Button className='app2-copy-btn' onClick={() => handleCopy(data.up)}>
            copy
          </Button>
        </div>
      </div>
      <div className='app2-box'>
        <div className='app2-box-head' style={{ marginBottom: '1rem' }}>
          <p>Step2:Transfer and don’t modify this amount to us.</p>
        </div>
        <div className='app2-box-body'>
          <div style={{ alignSelf: 'flex-start' }}>
            <RiErrorWarningFill className='red' style={{ width: '1.5rem' }} />
          </div>
          <p className='color-gray'>{`Please record your reference No {.Ref No.3} after payment`}</p>
        </div>
      </div>

      <Formik
        initialValues={{ UTR: '' }}
        validationSchema={schema}
        onSubmit={() => {
          Swal.fire({
            icon: 'success',
            title: 'Successfully!',
            text: 'Your payement will take 30 Minutes for a Review.',
            confirmButtonColor: '#79CBF2',
            confirmButtonText: 'Ok',
            reverseButtons: true
          });
        }}
      >
        {({ errors }) => (
          <Form>
            <div className='app2-box' style={{ paddingBottom: '.5rem' }}>
              <div className='app2-box-head' style={{ marginBottom: '1rem' }}>
                <p>Step3:Please enter Ref No. to complete the recharge</p>
              </div>
              <div className='app2-box-body'>
                <div style={{ alignSelf: 'flex-start' }}>
                  <RiErrorWarningFill
                    className='red'
                    style={{ width: '1.5rem' }}
                  />
                </div>
                <p className='color-gray'>
                  Be sure to <span className='red'>return</span> this page to
                  fill the <span className='red'>UTR numbers after</span> you
                  have completed your payment
                </p>
              </div>
              <Field
                name='UTR'
                className='text-ellipsis mt-2'
                placeholder='UTR (UPI Ref.ID must be 12 digits)'
                style={{
                  border: `1px solid lightgray`,
                  width: '90%',
                  padding: '0.5rem 1rem',
                  borderRadius: '5px'
                }}
              />
              <ErrorMessage
                component='div'
                name='UTR'
                style={{ textAlign: 'center', color: 'red' }}
              />
            </div>
            <button type='submit' className='mt-2 submit-app-2'>
              SUBMIT UTR
            </button>

            <p className='color-gray'>
              © 2023 Fastpay Technical Support. All Rights Reserved.
            </p>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default App2;
